/**
 * Format some data as a markdown table.
 * @param data Data to format
 * @param columns Columns to use. If an object, the key is the data object key and the value is the
 * column display name. Defaults to the keys of the first row.
 * @returns Formatted table text
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- any is required to allow arbitrary object types
export function table(data: Record<string, any>[], columns?: string[] | Record<string, string>): string {
  columns ??= Object.keys(data[0]);
  const columnKeys = Array.isArray(columns) ? columns : Object.keys(columns);
  const columnNames = Array.isArray(columns) ? Object.fromEntries(columns.map((name) => [name, name])) : columns;

  const stringData = data.map((row) => Object.fromEntries(columnKeys.map((key) => [key, String(row[key] ?? '')])));

  const columnWidths = Object.fromEntries(
    columnKeys.map((key) => [key, Math.max(columnNames[key].length, ...stringData.map((row) => row[key].length))]),
  );

  const header = Object.entries(columnNames).map(([key, name]) => name.padEnd(columnWidths[key]));

  const divider = columnKeys.map((key) => '-'.repeat(columnWidths[key]));

  const rows = stringData.map((row) => columnKeys.map((name) => row[name].padEnd(columnWidths[name])));

  return [header, divider, ...rows].map((row) => `| ${row.join(' | ')} |`).join('\n');
}
